import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'mycampapp-privacy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.less']
})
export class PrivacyComponent implements OnInit
{

	constructor() { }

	ngOnInit()
	{
	}

}
